import React from "react";
import "./TikTokForArtists.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const TikTokForArtists = () => {

  const steps = [
    "Create your FTTunes account",
    "Upload music & artwork",
    "Deliver music to TikTok",
    "Make your sound available for creators",
    "Go viral with short videos",
    "Track performance & earnings"
  ];

  return (
    <>
      <Helmet>

        <title>
          Get Your Music on TikTok | TikTok Music Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Upload your music to TikTok with FT Tunes. Make your songs available for millions of creators and grow your fanbase through viral short videos."
        />

        <meta
          name="keywords"
          content="TikTok music distribution, upload music to TikTok, TikTok for artists India, music distribution FT Tunes, release music TikTok"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="FT Tunes" />

        <meta
          property="og:title"
          content="Get Your Music on TikTok | FT Tunes"
        />

        <meta
          property="og:description"
          content="Distribute your music to TikTok and reach millions of creators worldwide. Go viral with FT Tunes music distribution."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://www.fttunes.com/get-music-on-tiktok"
        />

      </Helmet>

      <div className="tiktok-page">

        {/* HERO */}
        <section className="tiktok-hero">
          <Container>

            <img
              src="/Images/tiktok.webp"
              alt="Get Music on TikTok"
            />

            <h1>
              Get Your Music on TikTok
            </h1>

            <p>
              Turn your music into viral moments. Distribute your songs to TikTok
              and let creators use your sound in millions of videos worldwide.
            </p>

            <Button
              className="gradient-btn-tik-tok"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-tik-tok"></div>
        </section>

        {/* SHOWCASE */}
        <section className="tiktok-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Go Viral With TikTok Sounds</h2>

                <p>
                  TikTok is one of the world’s fastest-growing platforms for music
                  discovery. Upload your track and allow creators to use your sound
                  in trending videos.
                </p>

                <Button
                  as="a"
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Distribute Now
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-tik-tok.png"
                  alt="TikTok Music Distribution"
                  className="tiktok-image"
                />
              </Col>

            </Row>
          </Container>
        </section>

        {/* STEPS */}
        <section className="tiktok-steps">
          <Container>

            <h2 className="section-title">
              How It Works
            </h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>

        {/* BENEFITS */}
        <section className="tiktok-benefits">
          <Container>

            <h2 className="section-title">
              Built For Viral Growth
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Viral Exposure</h5>
                  <p>Your music can trend through creator videos.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Global Audience</h5>
                  <p>Reach millions of users worldwide instantly.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Music Monetization</h5>
                  <p>Earn royalties when your sound is used.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Artist Discovery</h5>
                  <p>Fans discover artists through trending sounds.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>

        {/* CTA */}
        <section className="tiktok-cta">
          <Container>
            <h2>Make Your Music Go Viral on TikTok</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Upload Your Music
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default TikTokForArtists;